import { BaseTbaParameter } from './base-tba-parameter';

export class ControlledParameter extends BaseTbaParameter {
  tbaControlledParameterId: number;
}
